import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import $ from "jquery";
import { UntypedFormBuilder, UntypedFormControl, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { ToastMessageData, ToastMessageOptions } from "@common/models";
import { ToastService } from "@common/services/toast.service";
import { ApiRequestService } from "@common/services/api-request.service";
import { SortEvent } from "@modules/reporting/directives";
import * as XLSX from "xlsx";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { map, startWith } from 'rxjs/operators';
import { ImportWizardComponent } from "../import-wizard/import-wizard.component";

let SUPORTEDDEVICES: any[] = [];
let TARIFFTYPEDATA: any[] = [];
let MUNICIPALREGIONDATA: any[] = [];
let PROPERTYTYPE: any[] = [];
@Component({
    selector: "sbpro-forms-import-meters",
    templateUrl: "./forms-import-meters.component.html",
    styleUrls: ["forms-import-meters.component.scss"],
    standalone: false
})
export class FormsImportMetersComponent implements OnInit, OnChanges, OnDestroy {
  csvData: any = "";
  csvHeaders: any = [];
  csvRows: any = [];
  importDataRows: any = [];
  meteringSections: Array<any> = [];
  modemManufacturers: Array<any> = [];
  modemTypes: Array<any> = [];
  meterManufacturerNames: Array<any> = [];
  meterModels: Array<any> = [];
  meteringSection = "";
  @ViewChild("responsePayloadModal")
  responsePayloadModal!: TemplateRef<unknown>;
  @ViewChild(ImportWizardComponent) importWizardComponent?: ImportWizardComponent;

  requiredColumns = [
    "Metering Section Name",
    "Metering Section Address",
    "Property Type",
    "Metering Section Region/Municipality",
    "Metering Point Name",
    "Point Of Connection",
    "Meter Group Type",
    "Thin Prepayment Status",
    "Is Occupied",
    "Meter Name",
    "Meter Model",
    "Meter Type",
    "Payment Type",
    "Register Type",
    "Is Billable",
    "Meter Serial Number/Device ID",
    "Is Master Meter",
  ];
  meterColumns = [
    "Metering Section Name",
    "Metering Section Region/Municipality",
    "Metering Section Address",
    "Metering Section Square Size",
    "Group/Area Name",
    "Group/Area Square Size",
    "Property Type",
    "Metering Point Name",
    "Point Of Connection",
    "Address",
    "Account No",
    "Enter ERF No",
    "Metering Point Square Size",
    "Meter Group Type",
    "Meter Pipe Size",
    "Meter Breaker Size",
    "Notified Maximum Demand",
    "Thin Prepayment Status",
    "Is Occupied",
    "Water Tariff Code",
    "Sanitation Tariff Code",
    "Electricity Tariff Code",
    "Modem Serial Number",
    "Meter Serial Number/Device ID",
    "Meter Name",
    "Meter Model",
    "Meter Type",
    "Is Billable",
    "Payment Type",
    "Reading Type",
    "Register Type",
    "Is Master Meter",
    "Latitude",
    "Longitude",
  ];
  meterGroupTypes: string[] = [];

  meteringPointForm = this.fb.group({
    meteringSectionID: ["", [Validators.required]],
    propertyTypeID: ["", [Validators.required]],
  });

  tarrifsPointForm = this.fb.group({
    regionName: [""],
    groupingID: [""],
    electricityTariffTypeID: [""],
    waterTariffTypeID: [""],
    sanitationTariffTypeID: [""],
    gasTariffTypeID: [""],
  });

  invalidData = false;
  pageImportData = 1;
  pageSizeImportData = 10;
  importModemResponses: any = [];
  importResponses: any = [];
  pageImportResults = 1;
  pageSizeImportResults = 10;

  formSummary: any = [];
  supportedDevices: any = [];
  responsePayload: any = "";
  page = 1;
  pageSize = 10;
  tariffPage = 1;
  tariffPageSize = 10;
  propertyTypePage = 1;
  propertyTypePageeSize = 10;
  municipalRegionPage = 1;
  municipalRegionPageeSize = 10;
  breakerPage = 1;
  breakerPageSize = 10;
  pipePage = 1;
  pipePageSize = 10;
  nominalVoltagePage = 1;
  nominalVoltagePageSize = 10;

  locationRegions: any = [];
  meteringPointAction = "add_metering_point";
  propertyTypes: any = [];
  waterTarrifTypes: any = [];
  electricityTarrifTypes: any = [];
  sanitationTarrifTypes: any = [];
  gasTarrifTypes: any = [];
  meterPipeSizes: any = [];
  meterBreakerSizes: any = [];
  nominalVoltages: { nominalVoltage: string }[] = [];
  regionName = "";
  meteringGroupTypes: any = [];
  meteringGroups: any = [];
  meteringPointDetails: any = [];
  propertyID = "";

  sortedColumn!: string;
  sortedDirection!: string;
  collectionSizeImportDataResponses = 0;

  importDataForm = this.fb.group({
    importDataCSV: ["", [Validators.required]],
    meteringFarmID: ["", [Validators.required]],
  });

  modemsList: any = [];
  modemSerialNumbers: any = [];

  //step: "info" | "tarrif" | "review" = "info";
  step: any = 'review';
  isMainMeter = false;
  meterType = "water";
  devicesSerialNumbers: any = [];
  devicesPointOfConnections: any = [];
  tariffTypeData: any;
  municipleRegionData: any;
  propertyTypesArr: any;
  municipalRegionArr: any;
  meteringSectionArr: any;
  meteringSectionAddressArr: any;
  tariffTypeArr: any;
  meteringPointNames: any = []

  filterMeterType = new UntypedFormControl("", { nonNullable: true });
  filterTariffType = new UntypedFormControl("", { nonNullable: true });
  filterMunicipalRegion = new UntypedFormControl("", { nonNullable: true });
  filterPropertyType = new UntypedFormControl("", { nonNullable: true });

  supportedDevices$!: Observable<any[]>;
  tariffTypeData$!: Observable<any[]>;
  municipleRegionData$!: Observable<any[]>;
  propertyTypes$!: Observable<any[]>;

  meterTypecollectionSize = 0
  tariffTypecollectionSize = 0
  municipalRegionCollectionSize = 0
  propertyTypecollectionSize = 0
  showImportPreview: boolean = false
  showImportResult: boolean = false
  isModalShimmerLoading = false;
  isPreviewShimmerLoading = false;
  meteringFarms: any;
  meteringFarmID: any;
  meteringFarmName: any;
  meterTypes: any;



  constructor(
    private apiRequest: ApiRequestService,
    private modalService: NgbModal,
    private router: Router,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private changeDetectorRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) { }
  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit() {
    this.importResponses = [];
    this.csvHeaders = [];
    this.csvData = [];
    this.importDataRows = [];
    this.meteringSection = localStorage.getItem("meteringFarm") as string;

    this.isModalShimmerLoading = true;

    this.meterType = localStorage.getItem("meterType") as string;
    this.getMeteringHierachy();
    this.getPropertyTypes();
    this.getSupoportedDevices();
    this.getDevices();
    this.loadTarrifTypes()
    this.getAllMunicipalRegions()
    this.getAllTariffs()
    this.loadMeterBreakerSizes();
    this.loadMeterPipeSizes();
    this.loadNominalVoltages();
    this.changeDetectorRef.detectChanges();
  }




  getAllMunicipalRegions() {
    this.changeDetectorRef.detectChanges();
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest
      .apiRequest(
        "tariffs/all_municipal_regions/",
        "all_municipal_regions.json",
        body
      )
      .subscribe((res) => {

        if (res.success) {
          this.municipleRegionData = res.data.regions
          MUNICIPALREGIONDATA = res.data.regions

          this.municipleRegionData$ = this.filterMunicipalRegion.valueChanges.pipe(
            startWith(''),
            map(text => this.searchMunicipalRegion(text))
          );



          this.municipalRegionArr = this.municipleRegionData.map((item: any) => item.municipalRegion)

        }
        this.changeDetectorRef.detectChanges();
      });
  }

  getDevices() {
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest
      .apiRequest("utilities/devices/", "devices.json", body)
      .subscribe(
        (res) => {
          if (res.success) {
          }

          const defaultOptions = {
            autohide: true,
            delay: 5000,
          };

          for (var i = 0; i < res.data.devices.length; i++) {
            this.devicesSerialNumbers.push(res.data.devices[i].deviceID);
            this.meteringPointNames.push(res.data.devices[i].meteringPointName)
            this.devicesPointOfConnections.push(res.data.devices[i].pointOfConnection)

          }
          this.isModalShimmerLoading = false;
          this.changeDetectorRef.detectChanges();
        },
        (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 5000,
          };

          let message = "";
          for (var i = 0; i < error.error.data.length; i++) {
            message += error.error.data[i] + "\n";
          }
          this.toastService.show("Device Search", message, {
            headerClasses: "bg-danger text-light",
            ...defaultOptions,
          });
          this.isModalShimmerLoading = false;
          this.changeDetectorRef.detectChanges();
        }
      );
  }


  getModemList(farmId: any) {
    let meteringFarmID = localStorage.getItem('meteringFarmID')
    let body: any = {
      payload: {
        meteringFarmID: farmId
        // meteringSectionID: parseInt(
        //   this.meteringPointForm.value.meteringSectionID as string
        // ),
      },
    };

    this.changeDetectorRef.detectChanges();
    this.modemSerialNumbers = [];

    const defaultOptions = {
      autohide: true,
      delay: 5000,
    };
    this.apiRequest
      .apiRequest("modems/modems_list/", "modems_list.json", body)
      .subscribe(
        (res) => {
          if (res.success) {
            if (res.data.modems.length > 0) {
              this.modemsList = res.data.modems;
              for (var i = 0; i < res.data.modems.length; i++) {
                this.modemSerialNumbers.push(res.data.modems[i].serialNumber);
              }
              this.changeDetectorRef.detectChanges();
            } else {
              this.toastService.show(
                "No Modems",
                "There are no modems linked to \n" + this.meteringFarmName,
                { headerClasses: "bg-warning text-light", ...defaultOptions }
              );
            }
          }




          this.changeDetectorRef.detectChanges();
        },
        (error: any) => {
          let message = "";
          for (var i = 0; i < error.error.data.length; i++) {
            message += error.error.data[i] + "\n";
          }

          this.toastService.show(
            "No Modems",
            "There are no modems linked to . \n",
            { headerClasses: "bg-warning text-light", ...defaultOptions }
          );
        }
      );

  }


  getMeteringHierachy() {
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    let jsonF = "metering_hierarchy.json";

    if (localStorage.getItem("pmLevel") == "2") {
      jsonF = "metering_hierarchy_2.json";
    } else {
      jsonF = "metering_hierarchy_3.json";
    }


     this.apiRequest.apiRequest("metering/metering_hierarchy/", jsonF, body)
         .subscribe(async (res) => {
   if (res.success) {
      if (res.data.meteringFarms) {
        this.meteringFarms = res.data.meteringFarms


        for (var i = 0; i < res.data.meteringFarms.length; i++) {
          for (
            var j = 0;
            j < res.data.meteringFarms[i].meteringSections.length;
            j++
          ) {
            this.meteringSections.push(
              res.data.meteringFarms[i].meteringSections[j]
            );
          }
        }
      } else if (res.data.meteringSections) {
        this.meteringSections = res.data.meteringSections;
      } else if (res.data.meteringPoints) {
        for (var j = 0; j < res.data.meteringPoints.length; j++) {
          this.meteringSections.push({
            meteringSectionID: res.data.meteringPoints[j].meteringSectionID,
            meteringSectionName: res.data.meteringPoints[j].meteringSectionName,
          });
        }
      }
    }


    this.meteringSectionArr = this.meteringSections.map((item: any) => item.meteringSectionName)
    this.meteringSectionAddressArr = this.meteringSections.map((item: any) => item.address)
    this.changeDetectorRef.detectChanges();
  })

  }

  getPropertyTypes() {
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest
      .apiRequest("metering/property_types/", "property_types.json", body)
      .subscribe((res) => {
        if (res.success) {
          this.propertyTypes = res.data.propertyTypes;
          PROPERTYTYPE = res.data.propertyTypes;

          this.propertyTypes$ = this.filterPropertyType.valueChanges.pipe(
            startWith(''),
            map(text => this.searchPropertyType(text))
          );


          this.propertyTypesArr = this.propertyTypes.map((item: any) => item.propertyType)
        }



        this.changeDetectorRef.detectChanges();
      });
  }

  loadMeterPipeSizes() {
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest
      .apiRequest("metering/meter_pipe_sizes/", "meter_pipe_sizes.json", body)
      .subscribe((res) => {
        if (res.success) {
          this.meterPipeSizes = res.data?.meterPipeSizes || [];
        }

        this.changeDetectorRef.detectChanges();
      });
  }

  loadMeterBreakerSizes() {
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest
      .apiRequest(
        "metering/meter_breaker_sizes/",
        "meter_breaker_sizes.json",
        body
      )
      .subscribe((res) => {
        if (res.success) {
          this.meterBreakerSizes = res.data?.meterBreakerSizes || [];
        }

        this.changeDetectorRef.detectChanges();
      });
  }

  loadNominalVoltages() {
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest
      .apiRequest(
        "metering/nominal_voltages/",
        "nominal_voltages.json",
        body
      )
      .subscribe((res) => {
        if (res.success) {
          this.nominalVoltages = (res.data?.nominalVoltages || [])
            .map((item: any) => ({
              nominalVoltage: String(item?.nominalVoltage ?? "").trim(),
            }))
            .filter(
              (item: { nominalVoltage: string }) => item.nominalVoltage !== ""
            );
        } else {
          this.nominalVoltages = [];
        }

        this.changeDetectorRef.detectChanges();
      });
  }


  searchMeterTypes(text: string): any[] {
    this.page = 1
    let meterTypeArr: any = [];
    return SUPORTEDDEVICES.filter((meter: any) => {
      const term = text.toLowerCase();
      let meterList: any = [];
      if (term != "") {
        meterList = meter.deviceName.toLowerCase().includes(term)
          || meter.deviceModel.toLowerCase().includes(term)
          || meter.requiresModem.toLowerCase().includes(term)
          || meter.meterTypes.toLowerCase().includes(term);

        if (meterList) {
          meterTypeArr.push(meter.deviceName);


          this.meterTypecollectionSize = meterTypeArr.length;
        }
      } else {
        this.refreshMeterType();
        this.meterTypecollectionSize = SUPORTEDDEVICES.length;
      }
      return meterList;

    });
  }

  searchTariffTypes(text: string): any[] {
    this.tariffPage = 1
    let tariffTypeArr: any = [];
    return TARIFFTYPEDATA.filter((tariff: any) => {
      const term = text.toLowerCase();
      let tariffTypeList: any = [];
      if (term != "") {
        tariffTypeList = tariff.tariffCode.toLowerCase().includes(term)
          || tariff.tariffName.toLowerCase().includes(term)
          || tariff.tariffType.toLowerCase().includes(term)
          || tariff.tariffCategory.toLowerCase().includes(term)
          || tariff.tariffCurrency.toLowerCase().includes(term)
          || tariff.municipality.toLowerCase().includes(term)
          || tariff.province.toLowerCase().includes(term)

        if (tariffTypeList) {
          tariffTypeArr.push(tariff.tariffName);
          this.tariffTypecollectionSize = tariffTypeArr.length;
        }
      } else {
        this.refreshTariffType();
        this.tariffTypecollectionSize = TARIFFTYPEDATA.length;
      }
      return tariffTypeList;

    });
  }

  searchMunicipalRegion(text: string): any[] {
    this.municipalRegionPage = 1
    let municipalRegionArr: any = [];
    return MUNICIPALREGIONDATA.filter((region: any) => {
      const term = text.toLowerCase();
      let municipalRegionList: any = [];
      if (term != "") {
        municipalRegionList = region.municipalRegion.toLowerCase().includes(term)
          || region.municipalRegionProvince.toLowerCase().includes(term)
          || region.municipalRegionAddress.toLowerCase().includes(term)
          || region.municipalRegionWebsite.toLowerCase().includes(term)


        if (municipalRegionList) {
          municipalRegionArr.push(region.municipalRegion);
          this.municipalRegionCollectionSize = municipalRegionArr.length;
        }
      } else {
        this.refreshMunicipalRegion();
        this.municipalRegionCollectionSize = MUNICIPALREGIONDATA.length;
      }
      return municipalRegionList;

    });
  }


  searchPropertyType(text: string): any[] {
    this.propertyTypePage = 1
    let propertyTypeArr: any = [];
    return PROPERTYTYPE.filter((propertyType: any) => {
      const term = text.toLowerCase();
      let propertyTypeList: any = [];
      if (term != "") {
        propertyTypeList = propertyType.propertyType.toLowerCase().includes(term)
        if (propertyTypeList) {
          propertyTypeArr.push(propertyType.propertyType);
          this.propertyTypecollectionSize = propertyTypeArr.length;
        }
      } else {
        this.refreshPropertyType();
        this.propertyTypecollectionSize = PROPERTYTYPE.length;
      }
      return propertyTypeList;

    });
  }


  refreshPropertyType() {
    this.propertyTypes = PROPERTYTYPE
      .map((integration, i) => ({ id: i + 1, ...integration }))
      .slice((this.propertyTypePage - 1) * this.propertyTypePageeSize, (this.propertyTypePage - 1) * this.propertyTypePageeSize + this.propertyTypePageeSize);
  }

  refreshMunicipalRegion() {
    this.municipleRegionData = MUNICIPALREGIONDATA
      .map((integration, i) => ({ id: i + 1, ...integration }))
      .slice((this.municipalRegionPage - 1) * this.municipalRegionPageeSize, (this.municipalRegionPage - 1) * this.municipalRegionPageeSize + this.municipalRegionPageeSize);
  }
  refreshTariffType() {
    this.tariffTypeData = TARIFFTYPEDATA
      .map((integration, i) => ({ id: i + 1, ...integration }))
      .slice((this.tariffPage - 1) * this.tariffPageSize, (this.tariffPage - 1) * this.tariffPageSize + this.tariffPageSize);
  }

  refreshMeterType() {
    this.supportedDevices = SUPORTEDDEVICES
      .map((integration, i) => ({ id: i + 1, ...integration }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  getSupoportedDevices() {
    let body = {
      payload: {
        platform: "utilities",
        installationTypeID: "all",
      },
    };

    this.apiRequest
      .apiRequest(
        "utilities/supported_device_types/",
        "supported_device_types.json",
        body
      )
      .subscribe((res) => {
        if (res.success) {
          let deviceTypes: any = [];

          for (var i = 0; i < res.data.deviceTypes.length; i++) {
            if (
              res.data.deviceTypes[i].meterTypes.indexOf("gas") > -1 ||
              res.data.deviceTypes[i].meterTypes.indexOf("water") > -1 ||
              res.data.deviceTypes[i].meterTypes.indexOf("electricity") > -1
            ) {
              if (
                this.meterManufacturerNames.indexOf(
                  res.data.deviceTypes[i].deviceModel
                ) < 0
              ) {
                this.meterManufacturerNames.push(
                  res.data.deviceTypes[i].deviceModel
                );
              }
              if (
                this.meterModels.indexOf(res.data.deviceTypes[i].deviceModel) <
                0
              ) {
                this.meterModels.push(res.data.deviceTypes[i].deviceModel);
              }
              deviceTypes.push(res.data.deviceTypes[i]);
            }
          }


          this.supportedDevices = deviceTypes;

          this.meterTypes = JSON.parse(JSON.stringify(deviceTypes));



          SUPORTEDDEVICES = deviceTypes;
          this.supportedDevices$ = this.filterMeterType.valueChanges.pipe(
            startWith(''),
            map(text => this.searchMeterTypes(text))
          );




        }
        this.changeDetectorRef.detectChanges();
      });
  }

  loadTarrifTypes() {
    let meteringSectionID: any = this.meteringPointForm.value.meteringSectionID;
    this.changeDetectorRef.detectChanges();
    setTimeout(() => {
      //this.getMeteringGroups();
      // this.getModemList();
    }, 2000);

    this.getMeteringGroupTypes(meteringSectionID);

    //lets get metering section region and match name
    for (var i = 0; i < this.meteringSections.length; i++) {
      if (meteringSectionID == this.meteringSections[i].meteringSectionID) {
        if (this.meteringSections[i].municipalRegion != null)
          this.regionName = this.meteringSections[i].municipalRegion;
        localStorage.setItem("municipalRegion", this.regionName);
      }
    }

    let body = {
      payload: {
        meteringPointID: parseInt(
          localStorage.getItem("meteringPointID") as string
        ),
        meteringSectionID: parseInt(meteringSectionID as string),
      },
    };

    let waterTarrifTypesArr: any = [];
    let electricityTarrifTypesArr: any = [];
    let sanitationTarrifTypesArr: any = [];
    let gasTarrifTypesArr: any = [];

    this.apiRequest
      .apiRequest(
        "metering/metering_tariff_types/",
        "metering_tariff_types.json",
        body
      )
      .subscribe((res) => {



        if (res.success) {

          for (var i = 0; i < res.data.tariffTypes.length; i++) {
            if (res.data.tariffTypes[i].tariffCategory == "water") {
              waterTarrifTypesArr.push(res.data.tariffTypes[i]);
            }
            if (res.data.tariffTypes[i].tariffCategory == "electricity") {
              electricityTarrifTypesArr.push(res.data.tariffTypes[i]);
            }
            if (res.data.tariffTypes[i].tariffCategory == "sanitation") {
              sanitationTarrifTypesArr.push(res.data.tariffTypes[i]);
            }
            if (res.data.tariffTypes[i].tariffCategory == "gas") {
              gasTarrifTypesArr.push(res.data.tariffTypes[i]);
            }
          }
        }

        this.waterTarrifTypes = waterTarrifTypesArr;
        this.electricityTarrifTypes = electricityTarrifTypesArr;
        this.sanitationTarrifTypes = sanitationTarrifTypesArr;
        this.gasTarrifTypes = gasTarrifTypesArr;

        this.changeDetectorRef.detectChanges();
      });
  }


  getAllTariffs() {
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    let jsonF = "all_tariffs.json";
    this.apiRequest
      .apiRequest("tariffs/all_tariffs/", jsonF, body)
      .subscribe((res) => {

        if (res.success) {
          this.tariffTypeData = res.data.tariffTypes
          TARIFFTYPEDATA = res.data.tariffTypes;
          this.tariffTypeData$ = this.filterTariffType.valueChanges.pipe(
            startWith(''),
            map(text => this.searchTariffTypes(text))
          );

          this.tariffTypeArr = this.tariffTypeData.map((item: any) => item.tariffCode)



        }
        this.changeDetectorRef.detectChanges();
      });
  }

  getMeteringGroupTypes(meteringSectionID?: any) {
    const parsedMeteringPointID = Number(localStorage.getItem("meteringPointID"));
    const rawMeteringSectionID =
      meteringSectionID ??
      this.meteringPointForm.value.meteringSectionID ??
      localStorage.getItem("meteringSectionID");
    const parsedMeteringSectionID = Number(rawMeteringSectionID);

    const payload: any = {};

    payload.userID = parseInt(localStorage.getItem("userID") as string)

    if (Number.isFinite(parsedMeteringPointID) && parsedMeteringPointID > 0) {
      payload.meteringPointID = parsedMeteringPointID;
    }
    if (Number.isFinite(parsedMeteringSectionID) && parsedMeteringSectionID > 0) {
      payload.meteringSectionID = parsedMeteringSectionID;
    }

    const body: any = {
      payload,
    };

    this.apiRequest
      .apiRequest(
        "metering/metering_group_types/",
        "metering_group_types.json",
        body
      )
      .subscribe((res) => {
        if (res.success) {
          this.meteringGroupTypes = res.data.meteringGroupTypes ?? [];
          this.meterGroupTypes = this.meteringGroupTypes
            .map((groupType: any) =>
              String(
                groupType?.meteringGroupType ??
                groupType?.meteringGroupTypeName ??
                groupType?.name ??
                ""
              ).trim()
            )
            .filter((groupType: string) => groupType !== "");

          for (var i = 0; i < this.meteringGroupTypes.length; i++) {
            if (
              this.meteringGroupTypes[i].meteringGroupTypeID ==
              this.meteringPointDetails.meteringGroupTypeID
            ) {
            }
          }
        } else {
          this.meteringGroupTypes = [];
          this.meterGroupTypes = [];
        }
        this.changeDetectorRef.detectChanges();
      }, () => {
        this.meteringGroupTypes = [];
        this.meterGroupTypes = [];
        this.changeDetectorRef.detectChanges();
      });
  }

  getMeteringGroups() {
    let meteringSectionID: any = this.meteringPointForm.value.meteringSectionID;

    let body = {
      payload: {
        meteringSectionID: parseInt(meteringSectionID),
      },
    };

    this.apiRequest
      .apiRequest(
        "metering/metering_section_groups/",
        "metering_section_groups.json",
        body
      )
      .subscribe((res) => {
        if (res.success) {
          this.meteringGroups = res.data.groupings;
        }

        this.changeDetectorRef.detectChanges();
      });
  }

  setPropertyID() {
    this.loadTarrifTypes();
    this.propertyID = $("#propertyTypeID").val() as string;
  }

  updateSanitation() {
    if (this.tarrifsPointForm.value.waterTariffTypeID != "other") {
      for (var i = 0; i < this.waterTarrifTypes.length; i++) {
        if (
          this.waterTarrifTypes[i].tariffTypeID ==
          this.tarrifsPointForm.value.waterTariffTypeID
        ) {
          for (var j = 0; j < this.sanitationTarrifTypes.length; j++) {
            if (
              this.waterTarrifTypes[i].propertyTypeID ==
              this.sanitationTarrifTypes[j].propertyTypeID
            ) {
              this.tarrifsPointForm.patchValue({
                sanitationTariffTypeID:
                  this.sanitationTarrifTypes[j].tariffTypeID,
              });
            }
          }
        }
      }
    } else {
      this.tarrifsPointForm.patchValue({
        sanitationTariffTypeID: "other",
      });
    }
    this.changeDetectorRef.detectChanges();
  }

  next_step(stepValue: any) {
    var error = false;

    if (stepValue == "tarrif") {
      setTimeout(() => {
        if (
          !localStorage.getItem("municipalRegion") ||
          localStorage.getItem("municipalRegion") == ""
        ) {
          this.tarrifsPointForm.patchValue({
            regionName: "Skip For Now",
          });
          $("#regionName").val("Skip For Now");
        } else {
          this.tarrifsPointForm.patchValue({
            regionName: localStorage.getItem("municipalRegion"),
          });
          $("#regionName").val(
            localStorage.getItem("municipalRegion") as string
          );
        }
      }, 1000);

      if (this.meteringPointForm.status !== "VALID") {
        return;
      }

      this.tarrifsPointForm.patchValue({
        waterTariffTypeID: "other",
        sanitationTariffTypeID: "other",
        electricityTariffTypeID: "other",
        gasTariffTypeID: "other",
      });
    }
    if (stepValue == "review") {
    }

    if (stepValue == "submit") {
    } else {
      this.step = stepValue;
    }
  }

  importData() {
    this.showImportPreview = false
    let infoImportDataID: string | undefined;



    if (this.importDataRows && this.importDataRows.length > 0) {
      let importPayload: any = [];

      for (let i = 0; i < this.importDataRows.length; i++) {
        if (
          this.importDataRows[i][0] == "Valid" ||
          this.importDataRows[i][0] == "Invalid"
        ) {
          this.importDataRows[i].splice(0, 1);
        }

        let deviceManufacturer = "";
        let deviceType = "";
        for (let j = 0; j < this.meterTypes.length; j++) {
          if (
            this.importDataRows[i][25].trim() != "" &&
            this.meterTypes[j].deviceModel.trim() != null &&
            this.importDataRows[i][25].trim() == this.meterTypes[j].deviceModel.trim()
          ) {
            deviceManufacturer = this.meterTypes[j].deviceManufacturer;
            deviceType = this.meterTypes[j].deviceType;
          }
        }

        let accountNum = this.importDataRows[i][10]
        accountNum = accountNum.toString()

        let erfNumber = this.importDataRows[i][11]
        erfNumber = erfNumber.toString()

        let modemSerialNo = this.importDataRows[i][22]
        modemSerialNo = modemSerialNo.toString()

        let modemSerialDeviceIdNo = this.importDataRows[i][23]
        modemSerialDeviceIdNo = modemSerialDeviceIdNo.toString()




        importPayload[i] = {
          meteringSectionName: this.importDataRows[i][0] ?? null,
          municipalRegion: this.importDataRows[i][1] ?? null,
          meteringSectionAddress: this.importDataRows[i][2] ?? null,
          meteringSectionSquareSize: this.importDataRows[i][3] ?? null,
          areaName: this.importDataRows[i][4] ?? null,
          areaSquareSize: this.importDataRows[i][5] ?? null,
          propertyType: this.importDataRows[i][6] ?? null,
          meteringPointName: this.importDataRows[i][7] ?? null,
          pointOfConnection: this.importDataRows[i][8] ?? null,
          address: this.importDataRows[i][9] ?? null,
          accountNumber: this.importDataRows[i][10] ? accountNum : null,
          erfNumber: this.importDataRows[i][11] ? erfNumber : null,
          squareSize: this.importDataRows[i][12] ?? null,
          meteringGroupType: this.importDataRows[i][13] ?? null,
          meterPipeSize: this.importDataRows[i][14] ?? null,
          meterBreakerSize: this.importDataRows[i][15] ?? null,
          notifiedMaximumDemand: this.importDataRows[i][16] ?? null,
          thinPrepaymentStatus: this.importDataRows[i][17] ?? null,
          isOccupied: this.importDataRows[i][18] ?? null,
          waterTariffCode: this.importDataRows[i][19] ?? null,
          sanitationTariffCode: this.importDataRows[i][20] ?? null,
          electricityTariffCode: this.importDataRows[i][21] ?? null,
          //gasTariffCode: this.importDataRows[i][20] ?? null,


          modemSerialNumber: this.importDataRows[i][22] ? modemSerialNo : null,
          deviceID: this.importDataRows[i][23] ? modemSerialDeviceIdNo : null,
          deviceName: this.importDataRows[i][24] ?? null,
          deviceManufacturer: deviceManufacturer,
          deviceModel: this.importDataRows[i][25] ?? null,
          deviceType: deviceType,
          meterType: this.importDataRows[i][26] ?? null,
          isBillable: this.importDataRows[i][27] ?? null,
          paymentType: this.importDataRows[i][28] ?? null,
          registerType: this.importDataRows[i][30] ?? null,
          isMasterMeter: this.importDataRows[i][31] ?? null,
          latitude: this.importDataRows[i][32] ?? null,
          longitude: this.importDataRows[i][33] ?? null,


        };
      }

      let body: any = {
        payload: {
          //   ...this.meteringPointForm.value,
          //   ...this.tarrifsPointForm.value,
        },
      };
      body.payload.importMeters = importPayload;
      //body.payload.meterType = this.meterType;


      //let meteringFarmID = localStorage.getItem('meteringFarmID')
      let meteringFarmID = this.meteringFarmID
      let userID = localStorage.getItem('userID')

      body.payload.meteringFarmID = meteringFarmID
      body.payload.userID = userID

      // if (body.payload.propertyTypeID == "other")
      //   body.payload.propertyTypeID = null;

      // if (body.payload.waterTariffTypeID == "other")
      //   body.payload.waterTariffTypeID = null;
      // if (body.payload.electricityTariffTypeID == "other")
      //   body.payload.electricityTariffTypeID = null;
      // if (body.payload.sanitationTariffTypeID == "other")
      //   body.payload.sanitationTariffTypeID = null;
      // if (body.payload.gasTariffTypeID == "other")
      //   body.payload.gasTariffTypeID = null;
      // else {
      //   body.payload.gasTariffTypeID = parseInt(body.payload.gasTariffTypeID);
      // }

      const defaultOptions = {};
      this.importResponses = [];
      this.importDataForm.patchValue({
        importDataCSV: "",
        meteringFarmID: ""

      });
      this.importDataForm.reset();
      this.toastService.show(
        "Import Meters",
        "Import is in progress, please be patient while we import your meters.",
        { headerClasses: "bg-info text-light", ...defaultOptions },
        "assets/toast-img/spinner.svg",
        false
      );
      infoImportDataID =
        this.toastService["toasts"][this.toastService["toasts"].length - 1]
          ?.uuid;
      try {
        this.apiRequest
          .apiRequest("utilities/import_devices/", "import_devices.json", body)
          .subscribe(
            (res) => {
              if (res.success && infoImportDataID) {
                if (res.data.totalSuccess > 0) {
                  localStorage.setItem('import_meter_response', 'success')
                }

                this.importResponses = res.data.importDevicesResponses;
                this.collectionSizeImportDataResponses =
                  this.importResponses.length;

                //this.csvHeaders = [];
                //this.csvRows = [];

                setTimeout(() => {
                  this.getMeteringHierachyReload();
                  this.getAccountHierachyReload();
                  this.getDevices();
                }, 2000);
                this.changeDetectorRef.detectChanges();
                this.toastService.remove(infoImportDataID);
                this.toastService.show(
                  "Import Meters",
                  "Your meter has been successfully imported for " + this.meteringFarmName + " with " + res.data.totalSuccess + " successful and " + res.data.totalFails + " failed records.",
                  {
                    headerClasses: "bg-success text-light",
                    ...defaultOptions,
                  },
                  "assets/toast-img/tick.svg"
                );
              } else {
                localStorage.setItem('import_meter_response', 'fail')
                this.toastService.remove(infoImportDataID!);
                this.toastService.show("Import Meters", res.message, {
                  headerClasses: "bg-danger text-light",
                  ...defaultOptions,
                });
              }
              this.showImportResult = true
              this.changeDetectorRef.detectChanges();
            },
            (error: any) => {
              localStorage.setItem('import_meter_response', 'fail')
              const defaultOptions = {};
              this.toastService.remove(infoImportDataID!);
              let message = "";
              if (error.error.data) {
                for (var i = 0; i < error.error.data.length; i++) {
                  message += error.error.data[i] + "\n";
                }
              }
              this.toastService.show("Import Meters", error.error.data, {
                headerClasses: "bg-danger text-light",
                ...defaultOptions,
              });
            }
          );
      } catch (error: any) {
        this.toastService.remove(infoImportDataID!);
        this.toastService.show("Import Meters", error.message, {
          headerClasses: "bg-danger text-light",
          ...defaultOptions,
        });
      }
    }
  }

  onSort({ column, direction }: SortEvent) {
    this.sortedColumn = column;
    this.sortedDirection = direction;
    this.changeDetectorRef.detectChanges();
  }

  parseCsvData() {
    this.importResponses = [];
    this.csvHeaders = [];
    this.changeDetectorRef.detectChanges();

    const rows = this.csvData.split("\n");
    this.csvHeaders = this.meterColumns;
    this.importDataRows = [];
    this.csvRows = [];
    let paymentTypes = [
      "postpaid",
      "prepaid",
      "thinPrepayment",
      "notApplicable",
    ];
    let registerTypes = ["cumulative", "demand"];
    let meterTypes = ["water", "electricity", "gas"];

    const defaultOptions = {
      autohide: true,
      delay: 5000,
    };

    let meterSerialNumbers: any = [];

    if (rows.length > 0) {
      let hasHeaders = false;
      let row = rows[0].split(";");
      if (row.length < 3) {
        row = rows[0].split(",");
      }

      if (row.length < 3) {
        this.toastService.show(
          "Import Meters",
          "The import is not valid. Please make sure csv files is Comma (,) or Semicolon (;) separated",
          { headerClasses: "bg-danger text-light", ...defaultOptions }
        );
        return false;
      }

      for (let i = 0; i < row.length; i++) {
        if (this.meterColumns.indexOf(row[i]) > -1) {
          hasHeaders = true;
        }
      }

      if (hasHeaders) {
        rows.shift();
      }



      let meterSectionsSerialNumbers: any = [];
      for (let i = 0; i < rows.length; i++) {
        let meteringSection: any = [];
        row = rows[i].split(";");

        if (row.length < 3) row = rows[i].split(",");

        if (row.length < 3) {
          continue;
        }

        let rowObject: any = [];
        let importDataRow: any = [];
        let rowStatus = true;




        for (let j = 0; j < this.csvHeaders.length; j++) {
          rowStatus = true;
          let star = "";
          let columnVal = row[j];

          importDataRow[j] = columnVal;

          //validate if empty and required
          if (
            columnVal == "" &&
            (j == 0 || j == 1 || j == 2 || j == 6 || j == 7 || j == 8 || j == 13 || j == 17 || j == 18 || j == 23 || j == 24 || j == 25 || j == 26 || j == 27 || j == 28 || j == 30)
          ) {
            rowStatus = false;
            columnVal = "Required *";
          } else if (
            //Metering Section Name
            j == 0
          ) {

            // if (
            //   this.meteringSectionArr.indexOf(columnVal.replace(/"/g, '')) < 0 || 
            //   meterSectionsSerialNumbers.indexOf(columnVal.replace(/"/g, '').toString()) > -1
            // ) {
            //   rowStatus = false;
            //   star = " * ";
            // }

            meteringSection = this.meteringSections.filter((item) => item.meteringSectionName == columnVal.replace(/"/g, ''))
            meterSectionsSerialNumbers.push(columnVal.toString());
          } else if (
            //Metering Section Region/Municipality  : validate diplicate metering section
            j == 1) {
            if (this.municipalRegionArr.indexOf(columnVal.toString()) < 0) {
              rowStatus = false;
              star = " * ";
            }
            meterSerialNumbers.push(columnVal.toString());
          } else if (
            // Metering Section Address
            j == 2
          ) {

            //  if(meteringSection[0]?.address != columnVal){
            //    rowStatus = false;
            //    star = " * "; 
            //  }
          } else if (
            //Group/Area Square Size 
            j == 5 &&
            columnVal != "" &&
            !this.validateNumberString(columnVal)
          ) {
            star = " * ";
          } else if (j == 7) {
            //validate duplicate metering points IDs

            // if (
            //   meterSerialNumbers.indexOf(columnVal.toString()) > -1 ||  this.meteringPointNames.indexOf(columnVal.toString()) < 0
            // ) {
            //   star = " * ";
            // }
            // if (columnVal.length < 6) {
            //   star = " * ";
            // }

            meterSerialNumbers.push(columnVal.toString());
          }
          // else if (
          //   (j == 11)  &&
          //   columnVal != "" &&
          //   !this.validateNumberString(columnVal)
          // ) {
          //   star = " * ";
          // }   
          else if (j == 22 || j == 25 || j == 26) {
            if (j == 22) {
              if (columnVal != '') {
                if (meteringSection.length > 0) {
                  let modemListing = this.modemsList.filter((item: any) => item.meteringSectionID == meteringSection[0].meteringSectionID)
                  if (modemListing.length > 0) {
                    /*  if (modemListing[0].serialNumber != columnVal) {
                       star = " * ";
                       rowStatus = false
                     } */
                    if (modemListing.some((modem: { serialNumber: string; }) => modem.serialNumber == columnVal)) {
                      star = " ";
                    } else {
                      star = " * ";
                      rowStatus = false
                    }
                  } else {
                    star = " * ";
                    rowStatus = false
                  }
                } else {
                  star = " * ";
                  rowStatus = false
                }
              }
            }

            for (let x = 0; x < this.meterTypes.length; x++) {
              if (
                j == 22 && this.meterTypes[x].deviceModel != null && row[25] == this.meterTypes[x].deviceModel.trim() &&
                this.meterTypes[x].requiresModem == "yes"
              ) {
                if (
                  columnVal == ''
                ) {
                  star = " * ";
                }
              } else if (j == 25 || j == 26) {
                if (this.meterTypes[x].deviceModel != null && row[25] == this.meterTypes[x].deviceModel.trim()) {
                  if (
                    this.meterTypes[x].meterTypes.includes(
                      row[26]
                    )
                  ) {
                    star = "";
                  }
                }
              }
            }

            if (j == 25 || j == 26) {
              if (j == 25) {
                let meterModel = this.meterTypes.filter((item: any) => item.deviceModel.trim() == columnVal.trim())
                if (meterModel.length > 0) {
                  if (meterModel[0].deviceModel.trim() != row[25].trim()) {
                    star = " * ";
                    rowStatus = false;
                  }
                } else {
                  star = " * ";
                  rowStatus = false;
                }
              }

              if (j == 26) {
                let meterModel = this.meterTypes.filter((item: any) => {
                  return (
                    item.meterTypes.trim() == columnVal.trim() &&
                    typeof row[25].trim() != 'undefined' &&
                    item.deviceModel.trim() == row[25].trim()
                  );
                });
                if (meterModel.length > 0) {
                  if (meterModel[0].meterTypes != row[26]) {
                    star = " * ";
                    rowStatus = false;
                  }
                } else {
                  star = " * ";
                  rowStatus = false;
                }
              }
            }
          }
          //  else if (
          //   //meter group type
          //    j == 13 && this.meterGroupTypes.indexOf(columnVal)
          // ) {
          //   rowStatus = false;
          //   star = " * ";
          // } 
          else if (
            //Is Occupied
            j == 18 &&
            columnVal.toLowerCase() != "yes" &&
            columnVal.toLowerCase() != "no"
          ) {
            star = " * ";
          } else if (
            //Water Tariff Code| Sanitation Tariff Code | Electricity Tariff Code
            (j == 19 || j == 20 || j == 21) && (columnVal != '') && (this.tariffTypeArr.indexOf(columnVal) < 0)
          ) {
            rowStatus = false;
            star = " * ";
          }
          else if ((j == 23)) {
            //meter serial number / device id
            let value = String(columnVal).trim()
            if (this.devicesSerialNumbers.indexOf(value) > -1) {
              rowStatus = true;
             // star = " * ";
            }
          }
          else if ((j == 8)) {
            //point of connection
            let value = String(columnVal).trim()
            if (this.devicesPointOfConnections.indexOf(value) > -1) {
              rowStatus = true;
             // star = " * ";
            }
          }
          else if (j == 28 && paymentTypes.indexOf(columnVal) < 0) {
            star = " * ";
          } else if (j == 30) {
            const meterType = row[25].trim();
            const allowedMeterTypes = [
              "E460 Smart Single Phase",
              "E460 Smart Three Phase",
              "E460 Split Meter",
              "E650 Smart Three Phase"
            ];


            if (allowedMeterTypes.includes(meterType)) {

              if (!registerTypes.includes(columnVal)) {
                star = " *";
                rowStatus = false;
              } else {
                star = " ";
                rowStatus = true;
              }
            } else {
              star = " ";
              rowStatus = true;
            }
          }
          else if (
            j == 25 &&
            meterTypes.indexOf(columnVal.toLowerCase()) < 0
          ) {
            star = " * ";
          } else if (
            //Is Billable
            (j == 27 || j == 31) &&
            columnVal.toLowerCase() != "yes" &&
            columnVal.toLowerCase() != "no"
          ) {
            star = " * ";
          } else if (
            j == 32 &&
            columnVal != "" &&
            !this.validateSingleCoordinate(columnVal, 'lat')
          ) {
            star = " * ";
          } else if (
            j == 33 &&
            columnVal != "" &&
            !this.validateSingleCoordinate(columnVal, 'lng')
          ) {
            star = " * ";
          }

          // else if ( 
          //   //Property Type
          //   j == 6 && this.propertyTypesArr.indexOf(columnVal) < 0
          // ) {
          //   rowStatus = false;
          //   star = " * ";
          // }else if (
          //   columnVal != "" &&
          //   columnVal != null &&
          //   columnVal != undefined &&
          //   (j == 4 || j == 7 || j == 11)
          // ) {
          //   if (j == 7 || j == 11) star = " * ";

          //   for (let x = 0; x < this.supportedDevices.length; x++) {
          //     if (
          //       j == 4 &&
          //       this.supportedDevices[x].deviceModel != null &&
          //       row[7] == this.supportedDevices[x].deviceModel.trim() &&
          //       this.supportedDevices[x].requiresModem == "yes"
          //     ) {
          //       if (this.modemSerialNumbers.indexOf(columnVal.toString()) < 0) {
          //         star = " * ";
          //       }
          //     } else if (j == 7 || j == 11) {
          //       if (
          //         this.supportedDevices[x]?.deviceModel != null &&
          //         row[7] == this.supportedDevices[x]?.deviceModel?.trim() &&
          //         this.meterModels.indexOf(row[7]) > -1
          //       ) {
          //         if (this.supportedDevices[x]?.meterTypes?.includes(row[11])) {
          //           star = "";
          //         }
          //       }
          //     }
          //   }
          // } else if (
          //   columnVal != "" &&
          //   columnVal != null &&
          //   columnVal != undefined &&
          //   j == 8 &&
          //   columnVal.toLowerCase() != "yes" &&
          //   columnVal.toLowerCase() != "no"
          // ) {
          //   star = " * ";
          // } else if (
          //   columnVal != "" &&
          //   columnVal != null &&
          //   columnVal != undefined &&
          //   j == 9 &&
          //   columnVal.toLowerCase() != "yes" &&
          //   columnVal.toLowerCase() != "no"
          // ) {
          //   star = " * ";
          // } else if (j == 10 && paymentTypes.indexOf(columnVal) < 0) {
          //   star = " * ";
          // } else if (
          //   columnVal != "" &&
          //   columnVal != null &&
          //   columnVal != undefined &&
          //   j == 11 &&
          //   meterTypes.indexOf(columnVal.toLowerCase()) < 0
          // ) {
          //   star = " * ";
          // } else if (
          //   columnVal != "" &&
          //   columnVal != null &&
          //   columnVal != undefined &&
          //   j == 12 &&
          //   columnVal != "" &&
          //   !this.validateCoordinates(columnVal)
          // ) {
          //   star = " * ";
          // } else if (
          //   columnVal != "" &&
          //   columnVal != null &&
          //   columnVal != undefined &&
          //   j == 13 &&
          //   columnVal != "" &&
          //   !this.validateCoordinates(columnVal)
          // ) {
          //   star = " * ";
          // } else if (
          //   columnVal.trim() != "" &&
          //   columnVal != null &&
          //   columnVal != undefined &&
          //   j == 14 &&
          //   columnVal != "" &&
          //   !this.validateNumberString(columnVal)
          // ) {
          //   star = " * ";
          // } else if (
          //   columnVal.trim() != "" &&
          //   columnVal != null &&
          //   columnVal != undefined &&
          //   j == 15 &&
          //   columnVal != "" &&
          //   !this.validateNumberString(columnVal)
          // ) {
          //   star = " * ";
          // } else if (
          //   j == 16 &&
          //   columnVal.trim() != "" &&
          //   columnVal != null &&
          //   columnVal != undefined
          // ) {
          //   if (!this.validateNumberString(columnVal)) star = " * ";
          // }

          if (!rowStatus) star = " * ";
          rowObject[j] = columnVal + star;
        }

        this.csvRows.push(rowObject);



        let metersecNameCSV = this.csvRows[0][0]


        this.csvRows[0][0] = metersecNameCSV.replace(/"/g, '')




        let metersecName = importDataRow[0]
        importDataRow[0] = metersecName.replace(/"/g, '')


        this.importDataRows.push(importDataRow);



      }
      this.csvHeaders = ["Status", ...this.csvHeaders];

      // Add status column
      this.csvRows.forEach((row: any[]) => {
        let status = "Valid"; // Start with Valid by default

        if (
          this.meterColumns.some((column, index) => row[index].includes("*"))
        ) {
          status = "Invalid";
        }
        if (status == "Valid") this.invalidData = true;
        row.unshift(status);
      });

      // Sort the csvRows with "Invalid" rows at the top
      this.csvRows.sort((a: any, b: any) => {
        // Compare the first element (index 0) which holds "Invalid" or "Valid"
        if (a[0] === "Invalid" && b[0] === "Valid") {
          return -1; // Move "Invalid" before "Valid"
        } else if (a[0] === "Valid" && b[0] === "Invalid") {
          return 1; // Move "Valid" after "Invalid"
        } else {
          return 0; // Keep order if both are the same
        }
      });

      this.showImportPreview = true
    } else {
      this.toastService.show(
        "Import Meters",
        "No meters found on import file",
        { headerClasses: "bg-danger text-light", ...defaultOptions }
      );
    }
  }

  excelSerialNumberToDateTime(serial: any): string {
    const utcDays = Math.floor(serial);
    const utcFraction = serial - utcDays;

    // Calculate the number of milliseconds from Excel epoch to Unix epoch
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const unixEpoch = Date.UTC(1970, 0, 1);
    const excelEpoch = Date.UTC(1900, 0, 0);

    // Calculate the UTC milliseconds
    let utcMilliseconds = excelEpoch + (utcDays - 1) * millisecondsPerDay;
    utcMilliseconds += utcFraction * millisecondsPerDay;

    // Create a new Date object and format it as needed
    const dateObj = new Date(utcMilliseconds);
    const dateString = `${dateObj.getFullYear()}-${(
      "0" +
      (dateObj.getMonth() + 1)
    ).slice(-2)}-${("0" + dateObj.getDate()).slice(-2)} ${(
      "0" + dateObj.getHours()
    ).slice(-2)}:${("0" + dateObj.getMinutes()).slice(-2)}:${(
      "0" + dateObj.getSeconds()
    ).slice(-2)}`;

    return dateString;
  }

  validateCoordinates(latLngStr: any) {
    // Regular expression to match latitude and longitude in the format "lat, lng"
    const latLngRegex =
      /^\s*([-+]?\d{1,2}(?:\.\d+)?),\s*([-+]?\d{1,3}(?:\.\d+)?)\s*$/;

    // Test the string against the regular expression
    const match = latLngRegex.exec(latLngStr);
    if (!match) {
      return false;
    }

    // Parse the latitude and longitude values
    const latitude = parseFloat(match[1]);
    const longitude = parseFloat(match[2]);

    // Validate the parsed values
    if (latitude < -90 || latitude > 90) {
      return false;
    }

    if (longitude < -180 || longitude > 180) {
      return false;
    }

    return true;
  }
  validateSingleCoordinate(value: string | number, type: 'lat' | 'lng'): boolean {
    // Convert value to a number if it's a string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    // Check if the value is a valid number
    if (isNaN(numValue)) {
      return false;
    }

    // Validate based on type (latitude or longitude)
    if (type === 'lat') {
      return numValue >= -90 && numValue <= 90;
    } else if (type === 'lng') {
      return numValue >= -180 && numValue <= 180;
    }

    return false;
  }

  validateNumberString(numStr: any) {
    // Regular expression to match valid number formats
    const numberRegex = /^\s*[-+]?\d*\.?\d+(e[-+]?\d+)?\s*$/i;

    // Test the string against the regular expression
    if (!numberRegex.test(numStr)) {
      return false;
    }

    // Parse the string to a number and check if it's NaN
    const number = parseFloat(numStr);
    return !isNaN(number);
  }

  processExcel(file: File) {
    this.isPreviewShimmerLoading = true;
    this.importDataRows = [];
    this.csvRows = [];
    this.csvHeaders = []
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    let paymentTypes = [
      "postpaid",
      "prepaid",
      "thinPrepayment",
      "notApplicable",
    ];
    let registerTypes = ["cumulative", "demand"];
    let meterTypes = ["water", "electricity", "gas"];

    const defaultOptions = {
      autohide: true,
      delay: 5000,
    };

    reader.onload = (e: any) => {
      const bstr: string = reader.result as string;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

      const wsname: string = wb.SheetNames[0];



      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const jsonData: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });

      let meterSerialNumbers: any = [];
      let meterSectionsSerialNumbers: any = [];

      if (jsonData.length > 0) {
        this.csvHeaders = this.meterColumns; // Extract headers from the first row
        //this.csvHeaders = jsonData[0]; // Extract headers from the first row





        let csvRows: any = [];

        csvRows = jsonData
          .slice(0)
          .filter((row) =>
            row.some((cell: any) => cell != null && cell !== "")
          ); // Remove headers from data and filter out empty rows

        let hasHeaders = false;
        for (let i = 0; i < csvRows[0].length; i++) {
          if (this.meterColumns.indexOf(csvRows[0][i]) > -1) {
            hasHeaders = true;
          }
        }
        if (hasHeaders) {
          csvRows.shift();
        }

        meterSerialNumbers = [];
        meterSectionsSerialNumbers = [];
        if (csvRows.length > 0) {

          for (let i = 0; i < csvRows.length; i++) {
            let meteringSection: any = [];
            let rowObject: any = [];
            let importDataRow: any = [];
            let rowStatus = true;
            for (let j = 0; j < this.csvHeaders.length; j++) {
              rowStatus = true;
              let star = "";
              let columnVal: any = "";
              if (csvRows[i][j] && csvRows[i][j] != "") {
                columnVal = csvRows[i][j];
              }

              const excludedValues = [
                "E460 Smart Single Phase",
                "E460 Smart Three Phase",
                "E460 Split Meter",
                "E650 Smart Three Phase"
              ];

              if (!excludedValues.includes(csvRows[i][25].trim())) {
                this.requiredColumns = this.requiredColumns.filter(col => col !== "Register Type");
              }

              //validate if empty and required
              if (
                columnVal == "" &&
                this.requiredColumns.indexOf(this.csvHeaders[j]) > -1
              ) {
                star = " * ";
              } else if (
                //Metering Section Name
                j == 0
              ) {


                // if(this.meteringSectionArr.indexOf(columnVal) < 0 || meterSectionsSerialNumbers.indexOf(columnVal.toString()) > -1 ){
                //   rowStatus = false;
                //   star = " * ";
                // }else{

                // }
                meteringSection = this.meteringSections.filter((item) => item.meteringSectionName == columnVal)
                meterSectionsSerialNumbers.push(columnVal.toString());
              } else if (
                //Metering Section Region/Municipality  : validate diplicate metering section
                j == 1) {
                if (this.municipalRegionArr.indexOf(columnVal.toString()) < 0) {
                  rowStatus = false;
                  star = " * ";
                }
                meterSerialNumbers.push(columnVal.toString());
              } else if (
                // Metering Section Address
                j == 2
              ) {
                // if(meteringSection[0]?.address != columnVal){
                //   rowStatus = false;
                //   star = " * "; 
                // }
              } else if (
                //Group/Area Square Size 
                j == 5 &&
                columnVal != "" &&
                !this.validateNumberString(columnVal)
              ) {
                star = " * ";
              } else if (
                //Property Type
                j == 6 && this.propertyTypesArr.indexOf(columnVal) < 0
              ) {
                rowStatus = false;
                star = " * ";
              }
              else if (j == 7) {
                //validate duplicate metering points IDs
                // if (
                //   meterSerialNumbers.indexOf(columnVal.toString()) > -1 || this.meteringPointNames.indexOf(columnVal.toString()) < 0
                // ) {
                //   star = " * ";
                // }
                // if (columnVal.length < 6) {
                //   star = " * ";
                // }
                meterSerialNumbers.push(columnVal.toString());
              }
              //  else if (
              //   (j == 11)  &&
              //   columnVal != "" &&
              //   !this.validateNumberString(columnVal)
              // ) {
              //   star = " * ";
              // }
              else if (j == 22 || j == 25 || j == 26) {
                if (j == 22) {
                  if (columnVal != '') {
                    if (meteringSection.length > 0) {
                      let modemListing = this.modemsList.filter((item: any) => item.meteringSectionID == meteringSection[0].meteringSectionID)
                      if (modemListing.length > 0) {
                        /* if (modemListing[0].serialNumber != columnVal) {
                          star = " * ";
                          rowStatus = false
                        } */
                        if (modemListing.some((modem: { serialNumber: string; }) => modem.serialNumber == columnVal)) {
                          star = " ";
                        } else {
                          star = " * ";
                          rowStatus = false
                        }

                      } else {
                        star = " * ";
                        rowStatus = false
                      }
                    } else {
                      star = " * ";
                      rowStatus = false
                    }
                  }
                }

                for (let x = 0; x < this.meterTypes.length; x++) {
                  if (
                    j == 22 && this.meterTypes[x].deviceModel != null && csvRows[i][25] == this.meterTypes[x].deviceModel.trim() &&
                    this.meterTypes[x].requiresModem == "yes"
                  ) {
                    if (
                      columnVal == ''
                    ) {
                      star = " * ";
                    }
                  } else if (j == 25 || j == 26) {
                    if (this.meterTypes[x].deviceModel != null && csvRows[i][25] == this.meterTypes[x].deviceModel.trim()) {
                      if (
                        this.meterTypes[x].meterTypes.includes(
                          csvRows[i][26]
                        )
                      ) {
                        star = "";
                      }
                    }
                  }
                }

                if (j == 25 || j == 26) {
                  if (j == 25) {
                    let meterModel = this.meterTypes.filter((item: any) => item.deviceModel.trim() == columnVal.trim())

                    if (meterModel.length > 0) {
                      if (meterModel[0].deviceModel.trim() != csvRows[i][25].trim()) {
                        star = " * ";
                        rowStatus = false;
                      }
                    } else {
                      star = " * ";
                      rowStatus = false;
                    }
                  }

                  if (j == 26) {
                    let meterModel = this.meterTypes.filter((item: any) => {
                      return (
                        item.meterTypes.trim() == columnVal.trim() &&
                        csvRows[i] &&
                        typeof csvRows[i][25].trim() != 'undefined' &&
                        item.deviceModel.trim() == csvRows[i][25].trim()
                      );
                    });

                    if (meterModel.length > 0) {
                      if (meterModel[0].meterTypes != csvRows[i][26]) {
                        star = " * ";
                        rowStatus = false;
                      }
                    } else {
                      star = " * ";
                      rowStatus = false;
                    }
                  }
                }
              }
              // else if (
              //   //meter group type
              //    j == 13 && this.meterGroupTypes.indexOf(columnVal)
              // ) {
              //   rowStatus = false;
              //   star = " * ";
              // } 
              else if (
                //Is Occupied
                j == 18 &&
                columnVal.toLowerCase() != "yes" &&
                columnVal.toLowerCase() != "no"
              ) {
                star = " * ";
              }
              else if (
                //Water Tariff Code| Sanitation Tariff Code | Electricity Tariff Code
                (j == 19 || j == 20 || j == 21) && (columnVal != '') && (this.tariffTypeArr.indexOf(columnVal) < 0)
              ) {
                rowStatus = false;
                star = " * ";
              }
              else if ((j == 23)) {
                //meter serial number / device id
                let value = String(columnVal).trim()
                if (this.devicesSerialNumbers.indexOf(value) > -1) {
                  rowStatus = true;
                 // star = " * ";
                }
              }
              else if ((j == 8)) {
                //point of connection
                let value = String(columnVal).trim()
                if (this.devicesPointOfConnections.indexOf(value) > -1) {
                  rowStatus = true;
                 // star = " * ";
                }
              }
              else if (j == 28 && paymentTypes.indexOf(columnVal) < 0) {
                star = " * ";
              } else if (j == 30) {
                const meterType = csvRows[i][25].trim();
                const allowedMeterTypes = [
                  "E460 Smart Single Phase",
                  "E460 Smart Three Phase",
                  "E460 Split Meter",
                  "E650 Smart Three Phase"
                ];


                if (allowedMeterTypes.includes(meterType)) {

                  if (!registerTypes.includes(columnVal)) {
                    star = " *";
                    rowStatus = false;
                  } else {
                    star = " ";
                    rowStatus = true;
                  }
                } else {
                  star = " ";
                  rowStatus = true;
                }
              }
              else if (
                j == 25 &&
                meterTypes.indexOf(columnVal.toLowerCase()) < 0
              ) {
                star = " * ";
              } else if (
                //Is Billable
                (j == 27 || j == 31) &&
                columnVal.toLowerCase() != "yes" &&
                columnVal.toLowerCase() != "no"
              ) {
                star = " * ";
              } else if (
                j == 32 &&
                columnVal != "" &&
                !this.validateSingleCoordinate(columnVal, 'lat')
              ) {
                star = " * ";
              } else if (
                j == 33 &&
                columnVal != "" &&
                !this.validateSingleCoordinate(columnVal, 'lng')
              ) {
                star = " * ";
              }
              // else if (
              //   j == 14 &&
              //   columnVal != "" &&
              //   !this.validateNumberString(columnVal)
              // ) {
              //   star = " * ";
              // } 
              // else if (
              //   j == 15 &&
              //   columnVal != "" &&
              //   !this.validateNumberString(columnVal)
              // ) {
              //   star = " * ";
              // } 
              // else if (
              //   j == 16 &&
              //   columnVal != "" &&
              //   !this.validateNumberString(columnVal)
              // ) {
              //   star = " * ";
              // }

              importDataRow[j] = columnVal;

              if (
                columnVal == "" &&
                (j == 0 || j == 1 || j == 2 || j == 6 || j == 7 || j == 8 || j == 13 || j == 17 || j == 18 || j == 23 || j == 24 || j == 25 || j == 26 || j == 27 || j == 28 || j == 31) &&
                !(["E460 Smart Single Phase", "E460 Smart Three Phase", "E460 Split Meter", "E650 Smart Three Phase"].includes(csvRows[i][25].trim()))
              ) {
                rowStatus = false;
                columnVal = "";
              } else if (
                columnVal == "" &&
                (j == 0 || j == 1 || j == 2 || j == 6 || j == 7 || j == 8 || j == 13 || j == 17 || j == 18 || j == 23 || j == 24 || j == 25 || j == 26 || j == 27 || j == 28 || j == 30 || j == 31) &&
                ["E460 Smart Single Phase", "E460 Smart Three Phase", "E460 Split Meter", "E650 Smart Three Phase"].includes(csvRows[i][25].trim())
              ) {
                rowStatus = false;
                columnVal = "Required *";
              }



              /* if (
                columnVal == "" &&
                (j == 0 || j == 1 || j == 2 || j == 6 || j == 7 || j == 8 || j == 13 || j == 17 || j == 18 || j == 23 || j == 24 || j == 25 || j == 26 || j == 27 || j == 28 || j == 31) && (csvRows[i][25].trim() != "E460 Smart Single Phase" &&
                csvRows[i][25].trim() != "E460 Smart Three Phase" &&
                csvRows[i][25].trim() != "E460 Split Meter" &&
                csvRows[i][25].trim() != "E650 Smart Three Phase")
              ) {
                rowStatus = false;
                columnVal = "";
              } else if (columnVal == "" &&
                (j == 0 || j == 1 || j == 2 || j == 6 || j == 7 || j == 8 || j == 13 || j == 17 || j == 18 || j == 23 || j == 24 || j == 25 || j == 26 || j == 27 || j == 28 || j == 31) && (csvRows[i][25].trim() == "E460 Smart Single Phase" &&
                csvRows[i][25].trim() == "E460 Smart Three Phase" &&
                csvRows[i][25].trim() == "E460 Split Meter" &&
                csvRows[i][25].trim() == "E650 Smart Three Phase")) {
                rowStatus = false;
                columnVal = "Required *";
              } */

              if (!rowStatus) star = " * ";
              rowObject[j] = columnVal + star;
            }

            this.csvRows.push(rowObject);
            this.importDataRows.push(importDataRow);
          }
          this.csvHeaders = ["Status", ...this.csvHeaders];
        }






        // Add status column
        this.csvRows.forEach((row: any[]) => {
          let status = "Valid"; // Start with Valid by default

          if (
            this.meterColumns.some((column, index) => row[index].includes("*"))
          ) {
            status = "Invalid";
          }
          if (status == "Valid") this.invalidData = true;
          row.unshift(status);
        });

        // Sort the csvRows with "Invalid" rows at the top
        this.csvRows.sort((a: any, b: any) => {
          // Compare the first element (index 0) which holds "Invalid" or "Valid"
          if (a[0] === "Invalid" && b[0] === "Valid") {
            return -1; // Move "Invalid" before "Valid"
          } else if (a[0] === "Valid" && b[0] === "Invalid") {
            return 1; // Move "Valid" after "Invalid"
          } else {
            return 0; // Keep order if both are the same
          }
        });

        this.isPreviewShimmerLoading = false;
        this.showImportPreview = true
      } else {
        this.isPreviewShimmerLoading = false;
        this.toastService.show(
          "Import Meters",
          "No meters found on import file",
          { headerClasses: "bg-danger text-light", ...defaultOptions }
        );
      }
    };
  }

  async onFileSelected(event: any) {
    this.csvHeaders = []
    this.csvRows = []
    this.showImportPreview = false
    this.showImportResult = false
    const defaultOptions = {
      autohide: true,
      delay: 5000,
    };



    if (this.importDataForm.status == 'INVALID') {
      this.importDataForm.patchValue({ importDataCSV: "" });
      this.toastService.show(
        "Import Meters",
        "Please select Metering Farms",
        { headerClasses: "bg-warning text-light", ...defaultOptions }
      );
      return
    }


    this.changeDetectorRef.detectChanges();
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    this.isPreviewShimmerLoading = true;
    const reader = new FileReader();
    const fileType = file.name.split(".").pop().toLowerCase();
    this.invalidData = false; //lets reset invalid

    this.importResponses = [];
    if (fileType === "csv") {
      reader.onload = () => {
        this.csvData = reader.result?.toString();
        this.parseCsvData();
      };
      reader.readAsText(file);
    } else if (fileType === "xls" || fileType === "xlsx") {
      this.processExcel(file);
    } else {
      this.isPreviewShimmerLoading = false;
    }

    const fileInput = document.getElementById('importDataCSV') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Reset the value
    }
  }

  clearForm() {
    this.importDataForm.patchValue({
      importDataCSV: ""
    });
  }

  exampleExcel() {
    this.downloadTemplateAsset(
      "assets/imports/devices_import_example.xlsx",
      "devices_import_example.xlsx"
    );
  }

  exampleCSV() {
    this.downloadTemplateAsset(
      "assets/imports/devices_import_example.csv",
      "devices_import_example.csv"
    );
  }

  private downloadTemplateAsset(relativePath: string, fileName: string) {
    const url = new URL(relativePath, document.baseURI).toString();
    this.http.get(url, { responseType: "blob" }).subscribe({
      next: (blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        }, 0);
      },
      error: () => {
        this.toastService.show("Import Meters", `Could not download ${fileName}.`, {
          headerClasses: "bg-danger text-light",
        });
      },
    });
  }

  viewPayload(payload: any) {
    this.responsePayload = JSON.parse(payload);
    this.modalService.open(this.responsePayloadModal).result.then(
      (result) => {
        if (result === "submit") {
        }
      },
      (reason) => { }
    );
    this.changeDetectorRef.detectChanges();
  }

  private cancelPendingOnDestroy = true;

  get isImportModalLocked(): boolean {
    return !!(this.importWizardComponent?.isProcessing && !this.importWizardComponent?.canDismissNote);
  }

  modalClose(shouldCancelPendingRequests: boolean = true) {
    if (this.isImportModalLocked) {
      return;
    }
    this.cancelPendingOnDestroy = shouldCancelPendingRequests;
    this.modalService.dismissAll();
  }

  getMeteringHierachyReload() {
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    let jsonF = "metering_hierarchy.json";

    if (localStorage.getItem("pmLevel") == "2") {
      jsonF = "metering_hierarchy_2.json";
    } else if (
      localStorage.getItem("pmLevel") == "3" ||
      localStorage.getItem("pmLevel") == "4"
    ) {
      jsonF = "metering_hierarchy_3.json";
    }

    this.apiRequest
      .apiRequest("metering/metering_hierarchy/", jsonF, body)
      .subscribe((res) => {
        if (res.success) {
        }
        this.changeDetectorRef.detectChanges();
      });
  }

  getAccountHierachyReload() {
    this.apiRequest.cancelPendingRequests();
    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    let jsonF = "account_hierarchy.json";

    if (localStorage.getItem("pmLevel") == "2") {
      jsonF = "account_hierarchy_2.json";
    } else if (
      localStorage.getItem("pmLevel") == "3" ||
      localStorage.getItem("pmLevel") == "4"
    ) {
      jsonF = "account_hierarchy_3.json";
    }

    this.apiRequest
      .apiRequest("metering/account_hierarchy/", jsonF, body)
      .subscribe((res) => {
        this.changeDetectorRef.detectChanges();
      });
  }

  onSelectMeteringFarm(event: any) {

    const selectedValue = event.target.value;
    if (selectedValue) {
      const [meteringFarmID, meteringFarmName] = selectedValue.split('|');
      this.meteringFarmID = meteringFarmID;
      this.meteringFarmName = meteringFarmName;
      this.getModemList(meteringFarmID)
      this.importDataForm.patchValue({
        importDataCSV: ""
      });
    }



  }

  ngOnDestroy(): void {
    if (this.cancelPendingOnDestroy) {
      this.apiRequest.cancelPendingRequests();
    }
  }

}
